// extracted by mini-css-extract-plugin
module.exports = {"create":"questionnaireListItemCreate_create__ubgRn","text":"questionnaireListItemCreate_text__89yrR","button":"questionnaireListItemCreate_button__apYP3"};